import { getToken } from "./authHeaderService";
import { apiInstance } from "./axiosService";

export const login = (payload) => {
  return apiInstance.post("user/crmLogin", payload);
};

export const passwordChange = (payload) => {
  return apiInstance.post("user/changeCrmPassword", payload, { headers: getToken() });
};
